import { Serializable } from '@admin/core/models/serializable';

export class EventModel implements Serializable<EventModel> {
  fromObject(obj: any): EventModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public eventId: number;
  public name: string;
  public urlShortName: string;
}
